// 登录、注册、忘记密码
const login = {
  anJun: {
    zh: '安骏跨境物流系统',
    en: '',
    pu: 'Sistema Logístico Cross Border de Anjun'
  },
  anjunKD: {
    zh: '安骏快递系统',
    en: '',
    pu: 'Sistema Anjun Express'
  },
  WELCOME: {
    zh: 'WELCOME',
    en: 'WELCOME',
    pu: 'Bem-vindo'
  },
  platformSubtitle: {
    zh: '欢迎回到安骏快递管理平台',
    en: 'Welcome back to Anjun Express Management Platform',
    pu: 'Bem-vindo de volta à plataforma de gestão Anjun Express'
  },
  login: {
    zh: '登录',
    en: '',
    pu: 'Fazer login'
  },
  welcome: {
    zh: '欢迎',
    en: '',
    pu: 'Bem-vindo'
  },
  email: {
    zh: '邮箱',
    en: '',
    pu: 'Email'
  },
  emailPrompt: {
    zh: '请输入邮箱',
    en: '',
    pu: 'Por favor digite o email'
  },
  password: {
    zh: '密码',
    en: '',
    pu: 'Senha'
  },
  passwordPrompt: {
    zh: '请输入密码',
    en: '',
    pu: 'Por favor digite a senha'
  },
  loginCode: {
    zh: '验证码',
    en: '',
    pu: 'Código de verificaçaõ'
  },
  inputPrompt: {
    zh: '请输入内容',
    en: '',
    pu: 'Por favor digite conteúdo'
  },
  isForget: {
    zh: '忘记密码？',
    en: '',
    pu: 'Esqueceu a senha?'
  },
  isRegistered1: {
    zh: '第一次登录？点击',
    en: '',
    pu: 'Login pela primeira vez? Clique'
  }, // 第一次登录？点击 注册
  isRegistered2: {
    zh: '注册',
    en: '',
    pu: 'Cadastrar'
  },
  getCode: {
    zh: '获取',
    en: '',
    pu: 'Obter'
  },
  ss: {
    zh: '秒',
    en: '',
    pu: 'segundos'
  },
  toObtain: {
    zh: '重新获取',
    en: '',
    pu: 'obter novamente'
  },
  raLogin: {
    zh: '立即登录',
    en: '',
    pu: 'Fazer login agora'
  },
  // 已有账号，立即登陆
  toLoginPrompt: {
    zh: '已有账号，立即',
    en: '',
    pu: 'Já tenho conta, login de imediato'
  },
  forget: {
    zh: '忘记密码',
    en: '',
    pu: 'Esqueci a senha'
  },
  // 登录时弱密码提示
  pwdTipTop: {
    zh: '提示',
    en: 'tips',
    pu: 'Dica'
  },
  pwdTipContent: {
    zh: '当前密码为弱密码，请更换密码',
    en: '',
    pu: 'A senha atual é fraca, por favor mude-a'
  },
  confirm: {
    zh: '确认',
    en: '',
    pu: 'confirmar'
  },
  changePwd: {
    zh: '修改密码',
    en: 'changePwd',
    pu: 'alterar a senha'
  },
  lginOut: {
    zh: '退出登录',
    en: 'lginOut',
    pu: 'logout'
  },
  inputNumber: {
    zh: '请输入账号',
    en: '',
    pu: 'Por favor digite o número de conta'
  },
  inputRightCode: {
    zh: '请输入正确的验证码',
    en: '',
    pu: 'Por favor digite o código de verificação correto'
  },
  quanxian: {
    zh: '将要跳转的页面没有权限访问',
    en: '',
    pu: 'A página a ser acessada não tem permissão de acesso'
  },
  verifyBeforeLogin: {
    zh: '请验证后再登录',
    en: 'Please verify before logging in',
    pu: 'Por favor, verifique antes de fazer login'
  },
  // 飞书登录
  feishuLogin: {
    zh: '飞书登录',
    en: 'Feishu Login',
    pu: 'Login com Feishu'
  },
  enterpriseLoginDivider: {
    zh: '或使用企业身份登录',
    en: 'Or sign in with enterprise identity',
    pu: 'Ou entre com identidade corporativa'
  },
  feishuLoginTips: {
    zh: '点击跳转到飞书授权页面',
    en: 'Click to redirect to Feishu authorization page',
    pu: 'Clique para redirecionar para a página de autorização Feishu'
  },
  feishuAppIdNotConfig: {
    zh: '飞书应用ID未配置，请联系管理员',
    en: 'Feishu App ID not configured, please contact administrator',
    pu: 'ID do aplicativo Feishu não configurado, entre em contato com o administrador'
  },
  loggingIn: {
    zh: '正在登录...',
    en: 'Logging in...',
    pu: 'Fazendo login...'
  },
  loginSuccess: {
    zh: '登录成功',
    en: 'Login successful',
    pu: 'Login realizado com sucesso'
  },
  feishuLoginFailed: {
    zh: '飞书登录失败',
    en: 'Feishu login failed',
    pu: 'Falha no login Feishu'
  },
  // 个人中心
  personalCenter: {
    zh: '个人中心',
    en: 'Personal Center',
    pu: 'Centro Pessoal'
  },
  username: {
    zh: '账号',
    en: 'Username',
    pu: 'Conta'
  },
  realName: {
    zh: '真实姓名',
    en: 'Real Name',
    pu: 'Nome Real'
  },
  phone: {
    zh: '手机号',
    en: 'Phone',
    pu: 'Telefone'
  },
  position: {
    zh: '职位',
    en: 'Position',
    pu: 'Cargo'
  },
  orgName: {
    zh: '部门名称',
    en: 'Department Name',
    pu: 'Nome do Departamento'
  },
  siteName: {
    zh: '网点名称',
    en: 'Site Name',
    pu: 'Nome do Site'
  },
  cpf: {
    zh: 'CPF',
    en: 'CPF',
    pu: 'CPF'
  },
  feishuStatus: {
    zh: '飞书状态',
    en: 'Feishu Status',
    pu: 'Status do Feishu'
  },
  feishuBound: {
    zh: '已绑定飞书',
    en: 'Feishu Bound',
    pu: 'Feishu Vinculado'
  },
  feishuNotBound: {
    zh: '未绑定飞书',
    en: 'Feishu Not Bound',
    pu: 'Feishu Não Vinculado'
  },
  bindFeishu: {
    zh: '绑定飞书',
    en: 'Bind Feishu',
    pu: 'Vincular Feishu'
  },
  unbindFeishu: {
    zh: '解绑飞书',
    en: 'Unbind Feishu',
    pu: 'Desvincular Feishu'
  },
  validaCode: {
    zh: '验证码',
    en: 'Verification Code',
    pu: 'Código de Verificação'
  },
  inputValidaCode: {
    zh: '请输入验证码',
    en: 'Please enter verification code',
    pu: 'Por favor digite o código de verificação'
  },
  sendCode: {
    zh: '发送验证码',
    en: 'Send Code',
    pu: 'Enviar Código'
  },
  sendCodeSuccess: {
    zh: '验证码发送成功',
    en: 'Verification code sent successfully',
    pu: 'Código de verificação enviado com sucesso'
  },
  sendCodeFailed: {
    zh: '验证码发送失败',
    en: 'Failed to send verification code',
    pu: 'Falha ao enviar código de verificação'
  },
  codeLengthError: {
    zh: '验证码长度为6位',
    en: 'Verification code must be 6 digits',
    pu: 'O código de verificação deve ter 6 dígitos'
  },
  bindSuccess: {
    zh: '绑定成功',
    en: 'Bind successful',
    pu: 'Vinculação bem-sucedida'
  },
  bindFailed: {
    zh: '绑定失败',
    en: 'Bind failed',
    pu: 'Falha na vinculação'
  },
  unbindSuccess: {
    zh: '解绑成功',
    en: 'Unbind successful',
    pu: 'Desvinculação bem-sucedida'
  },
  unbindFailed: {
    zh: '解绑失败',
    en: 'Unbind failed',
    pu: 'Falha na desvinculação'
  },
  getUserInfoFailed: {
    zh: '获取用户信息失败',
    en: 'Failed to get user info',
    pu: 'Falha ao obter informações do usuário'
  },
  popupBlocked: {
    zh: '弹窗被拦截，请允许弹窗后重试',
    en: 'Popup blocked, please allow popups and try again',
    pu: 'Pop-up bloqueado, permita pop-ups e tente novamente'
  },
  processing: {
    zh: '正在处理...',
    en: 'Processing...',
    pu: 'Processando...'
  },
  codeSent: {
    zh: '授权码已发送',
    en: 'Authorization code sent',
    pu: 'Código de autorização enviado'
  },
  closingWindow: {
    zh: '窗口即将关闭',
    en: 'Window will close soon',
    pu: 'A janela fechará em breve'
  },
  invalidCode: {
    zh: '无效的授权码',
    en: 'Invalid authorization code',
    pu: 'Código de autorização inválido'
  },
  unbindWarning: {
    zh: '解绑后将无法使用飞书账号登录系统，请谨慎操作',
    en: 'After unbinding, you will not be able to login with Feishu account, please proceed with caution',
    pu: 'Após desvincular, você não poderá fazer login com a conta Feishu, por favor prossiga com cautela'
  },
  basicInfo: {
    zh: '基本信息',
    en: 'Basic Information',
    pu: 'Informações Básicas'
  },
  feishuBoundDesc: {
    zh: '您已成功绑定飞书账号，可以使用飞书快捷登录',
    en: 'You have successfully bound your Feishu account, you can use Feishu for quick login',
    pu: 'Você vinculou com sucesso sua conta Feishu, pode usar o Feishu para login rápido'
  },
  feishuNotBoundDesc: {
    zh: '绑定飞书账号后，可以使用飞书快捷登录系统',
    en: 'After binding Feishu account, you can use Feishu for quick login',
    pu: 'Após vincular a conta Feishu, você pode usar o Feishu para login rápido'
  },
  // 飞书绑定页面
  feishuBindTitle: {
    zh: '绑定飞书账号',
    en: 'Bind Feishu Account',
    pu: 'Vincular Conta Feishu'
  },
  feishuBindSubtitle: {
    zh: '请输入您的系统账号和密码以完成绑定',
    en: 'Please enter your system account and password to complete binding',
    pu: 'Por favor, insira sua conta do sistema e senha para concluir a vinculação'
  },
  confirmBind: {
    zh: '确认绑定',
    en: 'Confirm Bind',
    pu: 'Confirmar Vinculação'
  },
  backToLogin: {
    zh: '返回登录',
    en: 'Back to Login',
    pu: 'Voltar ao Login'
  },
  invalidBindCode: {
    zh: '无效的绑定验证码',
    en: 'Invalid bind verification code',
    pu: 'Código de verificação de vinculação inválido'
  },
  accountBindRequired: {
    zh: '该飞书账号未绑定系统账号，请先绑定',
    en: 'This Feishu account is not bound to a system account, please bind first',
    pu: 'Esta conta Feishu não está vinculada a uma conta do sistema, por favor vincule primeiro'
  },
  brandSlogan: {
    zh: '安骏快递管理系统',
    en: 'Anjun Express Management System',
    pu: 'Sistema de Gestão Anjun Express'
  },
  brandName: {
    zh: '安骏',
    en: 'Anjun',
    pu: 'Anjun'
  },
  STREET_ERROR: {
    zh: '街道错误',
    en: 'Street error',
    pu: 'Rua incorreta'
  },
  HOUSE_NUMBER_ERROR: {
    zh: '门牌号错误',
    en: 'House number error',
    pu: 'Número incorreta'
  },
  HOUSE_NUMBER_MISSING: {
    zh: '缺少门牌号',
    en: 'House number missing',
    pu: 'Número ausente'
  },
  OTHER: {
    zh: '其它',
    en: 'Other',
    pu: 'Outros'
  },
  addressIssueType: {
    zh: '地址问题类型',
    en: 'Address Issue Type',
    pu: 'Tipo de Problema de Endereço'
  }
};
export { login };
